import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function securityReducer(state = initialState.security, action) {
	switch (action.type) {
		case types.AUTHORIZATION_INFO_LOADED: {
			return mergeDeep({}, action.body);
		}

        case types.SET_CURRENT_ORGANISATION: {
            let updatedState = mergeDeep({}, state);
            updatedState.currentOrganisationInfo = action.body.organisatie;

            return updatedState;
        }

		default:
			return state;
	}
}
